export function GetNomineesByCategory(category) {
    return NOMINEES.filter(nominee => nominee.category === category);
}

const WINNERS = [1, 4, 8, 11, 14];

export const GetWinners = () => {
    return NOMINEES.filter(nominee => WINNERS.includes(nominee.id));
}

export const EMPTY_TRAILBLAZER = {
    id: 0,
    name: '',
    category: '',
    restaurant: '',
    location: 'Location',
    instagram: '',
    description: '',
    image: 'restaurantPlaceholder.jpg',
    winImage: '',
    sharelink: '',
    orderlink: '',
};

export const NOMINEES = [
    {
        id: 1,
        name: 'Laura\'s Pizzas',
        category: 'female_chef',
        restaurant: 'Laura\'s Pizzas',
        location: 'South West',
        instagram: 'https://www.instagram.com/lauraspizzas/',
        description: `As a women-owned business, I’ve always tried to lead in a way that feels natural to me, not pretending to be someone I’m not or feeling the need to prove myself. 
        
        I just focus on doing the job well, growing the business, and making sure the team’s happy and supported.

What sets us apart is the level of attention we give to every part of the process. 

We don’t cut corners, we use traditional methods, source quality ingredients, and don’t compromise on flavour. 

Even though it’s a fast-paced takeaway, the care and craft behind the food is a big deal to us.

We also take customer satisfaction seriously. 

We always go above and beyond to make sure people are happy with their experience, whether that means fixing something quickly or just being thoughtful and responsive. 

We want every customer to feel like they’ve had a great experience, not just a quick meal.

It’s been really important to me to create a positive, encouraging workplace, especially for women stepping into kitchen roles. 

I’ve had some brilliant young women on the team and I love seeing them grow in confidence and skills.`,
        image: 'trailblazers/2025/laura-stone.jpg',
        winImage: '',
        sharelink: 'https://www.ubereats.com/store/lauras-pizzas/ibeXRAvCXla3b5Hj3SHlWQ',
        orderlink: 'https://www.ubereats.com/store/lauras-pizzas/ibeXRAvCXla3b5Hj3SHlWQ',
        isWinner: true
    },
    {
        id: 2,
        name: 'One Love Kitchen',
        category: 'female_chef',
        restaurant: 'One Love Kitchen',
        location: 'London',
        instagram: 'https://www.instagram.com/onelovekitchenuk/',
        description: `As a woman leading an independent Caribbean restaurant, I bring both heart and heritage to everything we do. 
        
        I excel in this space because I don’t just serve food - I serve culture, comfort, and connection. 
        
        Every dish on our menu tells a story, many of them rooted in generations of women before me who cooked with love, intention, and heart.

What sets us apart is our commitment to authenticity while being deeply community-minded. 

We go beyond simply offering and delivering meals - we create an experience that reminds people of home, even if they’re miles away. 

From sourcing ethically to honouring traditional methods, we strive to nourish the whole person - mind, spirit, and soul, not just their appetite.

Our impact is felt in the relationships we've built - with loyal customers, local producers, and the young women we mentor in hospitality. 

By showing that a Caribbean woman can lead a successful food business, I hope I’ve opened the door for others to dream bigger, work harder, and stay rooted in who they are.`,
        image: 'trailblazers/2025/one-love-kitchen.jpg',
        winImage: '',
        sharelink: 'https://www.ubereats.com/store/one-love-kitchen-islington/PYifGcQxTqqtA5E0XNkvjQ',
        orderlink: 'https://www.ubereats.com/store/one-love-kitchen-islington/PYifGcQxTqqtA5E0XNkvjQ',
        isWinner: false
    },
    {
        id: 3,
        name: 'Unit',
        category: 'female_chef',
        restaurant: 'Unit',
        location: 'Yorkshire',
        instagram: 'https://www.instagram.com/unit_sheffield/',
        description: `Lois is a true trailblazer whose dedication, resilience, and leadership make her an exceptional figure in the hospitality industry. 
        
        She leads by example, inspiring her team with a strong work ethic and unwavering commitment to excellence.

One winter, when heavy snow halted public transport across Sheffield, Lois walked over an hour to work determined not to let her team down. 

This act of dedication captured the spirit she brings every day: reliable, driven, and selfless.

Lois actively mentors younger staff, especially women, creating an inclusive and supportive environment where they are encouraged to grow and lead. 

Her efforts empower others and foster a culture of respect and opportunity.

Beyond the restaurant, she contributes to local food initiatives, championing access and education in the community.

Lois doesn’t just work in hospitality she elevates it. 

Her impact is felt not only in her workplace but in the wider community, making her a standout candidate for the Women in Food Award.`,
        image: 'trailblazers/2025/unit-yorkshire.jpg',
        winImage: '',
        sharelink: 'https://www.ubereats.com/store/unit-centertainment/iycV959-UCeHRwQ8Tp2CUQ',
        orderlink: 'https://www.ubereats.com/store/unit-centertainment/iycV959-UCeHRwQ8Tp2CUQ',
        isWinner: false
    },
    {
        id: 4,
        name: 'The Hogless Roast',
        category: 'sustainable_restaurant',
        restaurant: 'The Hogless Roast',
        location: 'London',
        instagram: 'https://www.instagram.com/thehoglessroast/',
        description: `The Hogless Roast, from its conception, has been built on a strong sustainability ethos. 
        
        From the start we committed to a 100% plant-based menu, due to the evidence showing the negative impact of large scale animal agriculture upon the environment. 
        
        This was a huge risk as plant-based only represents 2% of the market share. 
        
        So the idea was to broaden our target audience to include meat-eaters and flexitarians by creating delicious plant-based takes on meaty classics - to convince anyone that going plant-based, even for just a meal or two, can be a mouth watering experience as well as one that’s better for the environment.

In addition to this, we use 100% sustainable packaging. 

Recently teaming up with award winning seaweed packaging manufacturers NotPla, and becoming one of their Sustainability Heroes. 

We also operate at zero food waste. Everything is cooked to order so that there is no wastage from the kitchen, and stock ordering is meticulously controlled to avoid over ordering. 

Finally, food provenance is evaluated monthly so that we know where our food is coming from and making sure we order the most sustainable ingredients possible.`,
        image: 'trailblazers/2025/hogless-roast.jpg',
        winImage: '',
        sharelink: 'https://www.ubereats.com/store/the-hogless-roast-vegan/iAcImHboT_qEXCSnEDSl0A',
        orderlink: 'https://www.ubereats.com/store/the-hogless-roast-vegan/iAcImHboT_qEXCSnEDSl0A',
        isWinner: true
    },
    {
        id: 5,
        name: 'Eat Clean',
        category: 'sustainable_restaurant',
        restaurant: 'Eat Clean',
        location: 'North East',
        instagram: 'https://www.instagram.com/eatclean.uk',
        description: `At Eat Clean in Whitley Bay, sustainability is at the heart of everything we do. 
        
        As a healthy eating restaurant, we go beyond just nutritious food, we make climate conscious choices every step of the way. 
        
        We source locally and seasonally wherever possible, cutting down food miles and supporting ethical growers. Our packaging is 100% compostable, and we’ve eliminated single use plastics entirely. 
        
        What truly sets us apart is our low waste kitchen philosophy and our commitment to plant forward menus, which significantly lower our carbon footprint. 
        
        We also collaborate with local charities to ensure any surplus food supports our community, not landfill. 
        
        Through these efforts, we’ve reduced our food waste by over 80% and helped educate customers on the link between food choices and climate impact. 
        
        Eat Clean isn’t just a restaurant it’s part of a movement toward a healthier planet and lifestyle.`,
        image: 'trailblazers/2025/eat-clean.jpg',
        winImage: '',
        sharelink: 'https://www.ubereats.com/store/eat-clean/tiE_FSxqTNy4H-GkJdyIIQ',
        orderlink: 'https://www.ubereats.com/store/eat-clean/tiE_FSxqTNy4H-GkJdyIIQ',
        isWinner: true
    },
    {
        id: 6,
        name: 'Yaki Ya!',
        category: 'sustainable_restaurant',
        restaurant: 'Yaki Ya!',
        location: 'London',
        instagram: 'https://www.instagram.com/yakiya_uk/',
        description: `At Yaki Ya!, we’re proud to bring more than just bold Japanese flavours to the area - we bring responsibility. 
        
        Around 90% of our packaging is eco-friendly, with most of our containers made from sweetcorn, a sustainable material that turns into compost within 24 months of production. 
        
        We go a step further by using multi-compartment, sweetcorn-based takeaway boxes to keep our food fresh and separate, ensuring both quality and sustainability. 
        
        Where possible, we switch to paper-based boxes, and all our takeaway orders are packed in stylish, eco-conscious bags that reflect our commitment to both the planet and our brand aesthetics. 
        
        By doing this, we’re not only reducing our environmental impact, but also inspiring conscious dining in the community.`,
        image: 'trailblazers/2025/yaki-ya.jpg',
        winImage: '',
        sharelink: 'https://www.ubereats.com/store/yaki-ya%21-bubble-tea/oszsDlZ_XyWLg9opVlxajA',
        orderlink: 'https://www.ubereats.com/store/yaki-ya%21-bubble-tea/oszsDlZ_XyWLg9opVlxajA',
        isWinner: true
    },
    {
        id: 7,
        name: 'Macro Made',
        category: 'health_focused',
        restaurant: 'Macro Made',
        location: 'London',
        instagram: 'https://www.instagram.com/macromade.london/',
        description: `Macro Made is redefining healthy eating in London with macro-balanced comfort food that’s every bit as satisfying as it is nutritious. 
        
        Specialising in high-protein, low-calorie meals, they’ve created a menu where indulgence meets balance. 
        
        From air-fried burgers and protein pasta, to wraps and salad bowls, healthy eating just became exciting, guilt-free, and effortlessly enjoyable.

With visionary creativity, Macro Made chefs craft every sauce from scratch and reinvent comfort classics by swapping in lighter ingredients, layering flavours, and pioneering innovative techniques. 

Being the only business bold enough to commercially air fry, they are setting a new standard for how healthy food can look and taste.

What sets Macro Made apart is a commitment to transparency, quality, and sustainability at every stage. 

Every dish lists its calories and macros, empowering customers to make confident choices that align with their health goals. 

All poultry is halal and ingredients are sourced locally and sustainably. 

That same eco-conscious approach runs right through to the packaging, ensuring that at every stage each detail is as responsible as it is delicious. 

Surplus meals are redistributed through a consumer app so nothing goes to waste.

From its base in Kentish Town, Macro Made has built a loyal following of fitness enthusiasts, health-conscious professionals, and busy Londoners striving for balance. 

Macro Made proves that healthy food can be the most exciting thing you eat.`,
        image: 'trailblazers/2025/macro-made.jpg',
        winImage: '',
        sharelink: 'https://www.ubereats.com/store/macro-made/8BS3uevlSVe6zjnDeQw83g',
        orderlink: 'https://www.ubereats.com/store/macro-made/8BS3uevlSVe6zjnDeQw83g',
        isWinner: true
    },
    {
        id: 8,
        name: 'Eat Clean',
        category: 'health_focused',
        restaurant: 'Eat Clean',
        location: 'North East',
        instagram: 'https://www.instagram.com/eatclean.uk',
        description: `Eat Clean is committed to setting a high standard for healthy eating by combining nutrition, flavour, and sustainability in every dish we serve. 
        
        We prioritise whole, locally sourced ingredients, with a strong focus on seasonal produce, lean proteins, and vegetarian/vegan based options. 
        
        What sets us apart is our dedication to transparency from clearly labeled menus to allergen friendly choices ensuring our guests can make informed, health conscious decisions.

Beyond the plate, we actively engage in community wellness initiatives, partnering with local schools, fitness centers, and health organizations to promote education around balanced eating. 

We also offer workshops and meal planning support for those looking to adopt healthier lifestyles.

The impact has been significant: we’ve seen a positive shift in our guests’ habits, with many returning not just for the food, but for the support and resources we provide. 

Our approach has helped raise the standard for what a healthy dining experience can be in our area.`,
        image: 'trailblazers/2025/eat-clean.jpg',
        winImage: '',
        sharelink: 'https://www.ubereats.com/store/eat-clean/tiE_FSxqTNy4H-GkJdyIIQ',
        orderlink: 'https://www.ubereats.com/store/eat-clean/tiE_FSxqTNy4H-GkJdyIIQ',
        isWinner: true
    },
    {
        id: 9,
        name: 'Lean Cuisine',
        category: 'health_focused',
        restaurant: 'Lean Cuisine',
        location: 'North East',
        instagram: 'https://www.instagram.com/leancuisinegateshead/',
        description: `At our Gateshead-based healthy takeaway, we’ve redefined fast food by combining convenience with nutrition, serving over 1,000 meal preps weekly. 
        
        What sets us apart is our commitment to quality - fresh, locally sourced ingredients, chef-designed balanced meals, and full transparency with nutritional info. 
        
        Unlike traditional takeaways, we offer customizable meal prep plans tailored to fitness goals, dietary needs, and busy lifestyles, all while using eco-friendly packaging.

Our impact goes beyond food. 

We’ve helped customers build healthier habits, from gym-goers hitting macros to families eating better without the hassle. 

By partnering with local suppliers and hosting nutrition workshops, we’ve become a hub for community wellness. 

Whether it’s through student discounts or supporting grassroots fitness initiatives, we’re proud to make a difference in Gateshead - one healthy meal at a time.`,
        image: 'trailblazers/2025/lean-cuisine.jpg',
        winImage: '',
        sharelink: 'https://www.ubereats.com/store/lean-cuisine/O8YJ9PYzSA2IMTm9xP3C0w',
        orderlink: 'https://www.ubereats.com/store/lean-cuisine/O8YJ9PYzSA2IMTm9xP3C0w',
        isWinner: true
    },
    {
        id: 10,
        name: 'Chef X',
        category: 'social_impact',
        restaurant: 'Chef X',
        location: 'West Midlands',
        instagram: 'https://www.instagram.com/chefxcafe/',
        description: `At Chef X Café in Coventry, our mission is rooted in food, community, and positive change. We're more than a café - we're a hub for connection, empowerment, and social impact. 
        
        Every initiative we run is built around the idea that everyone, regardless of background, deserves opportunity and a place to belong.

One of our proudest ongoing initiatives is our free training program for local youth in collaboration with Rising Stars Youth group. 

We regularly open our kitchen to young people from the area, offering certified training in food hygiene and preparation, giving them both practical skills and a head start into hospitality careers. 

This hands-on experience not only empowers the next generation but also helps them build confidence, discipline, and a sense of purpose.

Mental health is another cause close to our hearts. We host regular “Chai and Chat” mornings, offering a safe, non-judgmental space where people from all walks of life can sit down over a warm cup of tea and talk openly about their mental health challenges. 

It’s a simple idea with powerful results, breaking stigma, building community, and showing people they’re not alone.

During Ramadan, we organised a grand community Iftar in collaboration with Coventry City Football Club and Rising Stars Youth Group, welcoming people of all faiths and backgrounds to share a meal together. 

Over 400 people attended, many of whom said it was the most inclusive and meaningful community event they had experienced. It was more than just a meal - it was unity in action.

Our commitment to community doesn’t stop at Coventry’s borders. 

We’ve funded and helped build water wells in underdeveloped countries, ensuring access to clean water in areas where it’s most needed. 

These international efforts are a natural extension of our local work, driven by compassion, responsibility, and the desire to give back.

We also believe in inspiring the younger generation early. 

Through our open days for local schoolchildren, we invite classes to visit the café, meet our team, and see how a real hospitality business operates. 

These visits give children a sense of aspiration and show them that there are many positive paths available to them.

At Chef X, we’re not just serving food - we’re serving futures, building bridges, and changing lives, one plate and one person at a time.`,
        image: 'trailblazers/2025/chef-x.jpg',
        winImage: '',
        sharelink: 'https://www.ubereats.com/store/chef-x-cafe/nAnAK2e_SBGvVHYXR59n5Q',
        orderlink: 'https://www.ubereats.com/store/chef-x-cafe/nAnAK2e_SBGvVHYXR59n5Q',
        isWinner: true
    },
    {
        id: 11,
        name: 'Piatto',
        category: 'social_impact',
        restaurant: 'Piatto',
        location: 'Scotland',
        instagram: 'https://www.instagram.com/piatto44/',
        description: `At Piatto Glasgow, social impact is at the heart of everything we do.
        
        We believe food has the power to bring people together, and we’ve built our business around supporting the community that supports us. 
        
        Beyond serving great meals, we’ve focused on creating real opportunities for people of all ages and backgrounds.

We proudly sponsor several local youth sports teams, including two basketball teams through the Glasgow Rens, covering league fees, providing nutritious meals, and supplying equipment so that children from underprivileged backgrounds can compete at the highest level. 

We also sponsor the Glasgow Goals Ladies 5‑a‑side football league and fund MNBJJ ladies‑only Brazilian Jiu‑Jitsu classes, helping women access sports that are often male‑dominated.

During the COVID‑19 pandemic, we launched our Pay It Forward campaign, gaining national TV and radio recognition as we provided over 3,000 free meals to NHS staff. 

We’ve also regularly donated to food banks, collaborated with Strath Foodsharing, and provided discounts to blue‑light workers, ensuring ongoing support for those who protect and care for our city.

What makes us different is that we never say no to charity. 

Over the years, we’ve supported hundreds of local fundraisers and initiatives, proving that our mission goes far beyond food - it’s about fuelling futures and lifting up our community.`,
        image: 'trailblazers/2025/piatto.jpg',
        winImage: '',
        sharelink: 'https://www.ubereats.com/store/piatto/6hxxP8b-RHCu2Btfr3Xkaw',
        orderlink: 'https://www.ubereats.com/store/piatto/6hxxP8b-RHCu2Btfr3Xkaw',
        isWinner: true
    },
    {
        id: 12,
        name: 'The Indian Street Kitchen',
        category: 'social_impact',
        restaurant: 'The Indian Street Kitchen',
        location: 'Wales',
        instagram: 'https://www.instagram.com/theindianstreetkitchen/',
        description: `The Indian Street Kitchen has rapidly become a favorite among locals, primarily because of our strong commitment to community impact and engagement. 
        
        Our unique approach sets us apart, as we skillfully blend authentic Indian flavors with elements of British street food culture. 
        
        This fusion not only results in delicious dishes but also introduces creative twists on traditional recipes, making our menu enticing and encouraging customers to return for more.

However, our mission extends beyond serving exceptional food. 

We prioritise community engagement through a variety of initiatives, including campaigns, collaborations, and charitable efforts. 

These activities are designed to foster a sense of connection and support within the community. 

We believe in the power of collaboration and often encourage other small businesses to join forces, creating a vibrant network that nurtures a sense of belonging for everyone involved.

At The Indian Street Kitchen, we are dedicated to building a community that thrives on shared experiences, mutual support, and a passion for good food. 

This holistic approach not only enhances our restaurant's reputation but also strengthens the fabric of our local community, making it a better place for all.`,
        image: 'trailblazers/2025/isk.jpg',
        winImage: '',
        sharelink: 'https://www.ubereats.com/store/the-indian-street-kitchen/Qq-7mxuGRhqoEZRHHEmuqg',
        orderlink: 'https://www.ubereats.com/store/the-indian-street-kitchen/Qq-7mxuGRhqoEZRHHEmuqg',
        isWinner: false
    },
    {
        id: 13,
        name: 'Unit',
        category: 'next_gen',
        restaurant: 'Unit',
        location: 'Yorkshire',
        instagram: 'https://www.instagram.com/unit_sheffield/',
        description: `This vote is for Ziad, who joined us age 16 years old. 
        
        Since then he's worked and mastered all Front of House stations and developed fast.

He now has been promoted to boh and manage to train on all stations, and sometimes single handedly runs a kitchen by himself. 

Still only 18 his future looks bright.

Amazing desire to succeed and an absolute star!`,
        image: 'trailblazers/2025/unit-sheffield.jpg',
        winImage: '',
        sharelink: 'https://www.ubereats.com/store/unit-centertainment/iycV959-UCeHRwQ8Tp2CUQ',
        orderlink: 'https://www.ubereats.com/store/unit-centertainment/iycV959-UCeHRwQ8Tp2CUQ',
        isWinner: false
    },
    {
        id: 14,
        name: 'Aros',
        category: 'next_gen',
        restaurant: 'Aros',
        location: 'North West',
        instagram: 'https://www.instagram.com/aros_kitchen/',
        description: `I’m Aras, a trilingual immigrant - fluent in Kurdish, English, and Dutch - who moved to the UK ten years ago for a better life. 
        
        I built Aros Kitchen from my mum’s kitchen on a council estate into a fast-growing brand with three branches, our own butcher, and a loyal customer base. 
        
        Alongside running the business, I recently completed my Law degree at the University of Manchester and got married - all while continuing to expand Aros Kitchen.

Across our social media channels, we’ve gained over 100,000 followers and millions of views, turning Aros into a recognised name well beyond our local area. 

My parents always believed that getting a degree was the key to success. I’ve honoured that, but I’ve also shown them that starting your own business is just as powerful. 

Winning a Next Gen award would be the final piece that brings it all together.

We’re active in our community too - partnering with the Mayor of Warrington on charity work and supporting those in need. 

Local kids often drop by the shop just to meet “Aras” because they’ve seen someone who came from their world and made something big. 

I carry that responsibility with pride - this journey is bigger than just me.`,
        image: 'trailblazers/2025/aros.jpg',
        winImage: '',
        sharelink: 'https://www.ubereats.com/store/aros-kitchen-warrington/VvVcFOs7XA6jjLjeatESzg',
        orderlink: 'https://www.ubereats.com/store/aros-kitchen-warrington/VvVcFOs7XA6jjLjeatESzg',
        isWinner: true
    },
    {
        id: 15,
        name: 'Matteo\'s Cucina Italiana Ltd',
        category: 'next_gen',
        restaurant: 'Matteo\'s Cucina Italiana Ltd',
        location: 'London',
        instagram: 'https://www.instagram.com/matteos_cucina_italiana/',
        description: `I’m Matteo, originally from Colleferro, near Rome. 
        
        My grandfather ran a butchery in Australia, and my father returned to Italy to open a bakery, and later bars and coffee shops, in Rome, where I grew up. 
        
        Since childhood I was passionate about food, and every summer I honed authentic recipes and kitchen operations working in my uncle’s Italian restaurants in the U.S.

After graduating from culinary high school in Rome, I moved to London alone to open my first kitchen on Caledonian Road. 

Its success led me to launch a second site in Hackney Wick, and I've been expanding ever since. We serve fresh pasta, slow-roasted meats, and house-made breads - bringing genuine Italian flavors to takeaway diners.

I’m obsessed with combining premium ingredients and streamlined operations to ensure every order arrives perfectly. 

My goal is to expand into major UK cities and, within three to five years, across Europe. 

Winning the Uber Eats Next Generation Award would recognize our rapid growth and provide the platform to accelerate expansion, invest in local suppliers, and inspire our team to continue sharing true Italian cuisine with even more communities.`,
        image: 'trailblazers/2025/matteos.jpg',
        winImage: '',
        sharelink: 'https://www.ubereats.com/store/matteos-cucina-italiana-bermondsey/D02gH6y5VK-phuQ1-xQ3dg',
        orderlink: 'https://www.ubereats.com/store/matteos-cucina-italiana-bermondsey/D02gH6y5VK-phuQ1-xQ3dg',
        isWinner: false
    }
];

/* export const NOMINEES = [
    {
        id: 1,
        name: 'Sara Ibrahim',
        category: 'female_chef',
        restaurant: 'Smoke & Pepper',
        location: 'London',
        instagram: 'https://www.instagram.com/smokeandpepperldn/',
        description: `As a strong woman in business, I believe women’s abilities are often underestimated. I’ve worked tirelessly to move Smoke & Peppers forward, helping grow it into the community hub it is today. From making key decisions to creating a vision that reflects our values, I’ve been deeply involved in every step of the journey. As a co-owner, I’ve shown that women can not only manage a business but lead it to success.

Our restaurant has brought the community together by hosting events, supporting local causes, and building partnerships with organisations that help those in need. We’ve created opportunities for others, especially women, and have made it a priority to give back. But this is just the beginning—there is so much more we plan to achieve. I’m committed to pushing Smoke & Peppers even further, proving that women in business can break barriers and make a lasting impact.`,
        image: ['trailblazers/SmokeandPepper-SaraIbrahim.jpeg', 'trailblazers/SmokePepperBow1.jpg', 'trailblazers/SmokePepperBow2.jpg', 'trailblazers/SmokePepperBow3.jpg', 'trailblazers/SmokePepperBow4.jpg'], // 'placeholder-trailblazers/nom1.jpg', // Supports Carousels: ['placeholder-trailblazers/nom1.jpg', 'placeholder-trailblazers/nom2.jpg', 'placeholder-trailblazers/nom3.jpg'],
        winImage: '2024-winners/sarah-ibrahim-2024.jpg',
        isWinner: true,
        sharelink: 'https://www.ubereats.com/gb/store/smoke-%26-pepper-bow/CKERs5jqWyCOcj5-u_sw-A?diningMode=DELIVERY&pl=JTdCJTIyYWRkcmVzcyUyMiUzQSUyMkxvbmRvbiUyMiUyQyUyMnJlZmVyZW5jZSUyMiUzQSUyMkNoSUpkZDRocnd1ZzJFY1JtU3JWM1ZvNmxsSSUyMiUyQyUyMnJlZmVyZW5jZVR5cGUlMjIlM0ElMjJnb29nbGVfcGxhY2VzJTIyJTJDJTIybGF0aXR1ZGUlMjIlM0E1MS41MDcyMTc4JTJDJTIybG9uZ2l0dWRlJTIyJTNBLTAuMTI3NTg2MiU3RA%3D%3D',
        orderlink: 'https://www.ubereats.com/gb/store/smoke-%26-pepper-bow/CKERs5jqWyCOcj5-u_sw-A?diningMode=DELIVERY&pl=JTdCJTIyYWRkcmVzcyUyMiUzQSUyMkxvbmRvbiUyMiUyQyUyMnJlZmVyZW5jZSUyMiUzQSUyMkNoSUpkZDRocnd1ZzJFY1JtU3JWM1ZvNmxsSSUyMiUyQyUyMnJlZmVyZW5jZVR5cGUlMjIlM0ElMjJnb29nbGVfcGxhY2VzJTIyJTJDJTIybGF0aXR1ZGUlMjIlM0E1MS41MDcyMTc4JTJDJTIybG9uZ2l0dWRlJTIyJTNBLTAuMTI3NTg2MiU3RA%3D%3D',
    },
    {
        id: 2,
        name: 'Anna Robertson',
        category: 'female_chef',
        restaurant: 'Freddy & Hicks',
        location: 'Glasgow',
        instagram: 'https://www.instagram.com/freddyandhicks/?hl=en-gb',
        description: `We are a team of 3 female cooks, all mothers with 8 kids between us, working with the best ingredients we can find to nourish our customers! We use grass-fed Scottish beef in our smash burgers and make our veggie & vegan patties to a secret family recipe, fresh every day. We want to offer something comforting for everyone no matter their dietary requirements, all under one roof.

We started doing street food in 2016 and moved to a cafe in 2019. We serve grass-fed beef, halal chicken, veggie & vegan burgers, loaded fries, mac & cheese, loaded salads & luxurious milkshakes. We offer something for everyone!

We are trying to serve the best quality comfort food with lots of love and a feminine touch. In 5 years we hope to still be going strong and have some of children working with us, one big family!`,
        image: ['trailblazers/FreddyHicks-AnnaRobertson.jpeg', 'trailblazers/FreddyHicks_2.jpg'], // 'placeholder-trailblazers/nom1.jpg', // Supports Carousels: ['placeholder-trailblazers/nom1.jpg', 'placeholder-trailblazers/nom2.jpg', 'placeholder-trailblazers/nom3.jpg'],
        winImage: '2023-winners/female-chef-2023.jpg',
        sharelink: 'https://www.ubereats.com/gb/store/freddy-%26-hicks/pK8BzomcWemHJZYIs43zzQ?diningMode=DELIVERY&pl=JTdCJTIyYWRkcmVzcyUyMiUzQSUyMk1hbmNoZXN0ZXIlMjIlMkMlMjJyZWZlcmVuY2UlMjIlM0ElMjJDaElKMl9VbVVreE5la2dScW12LUJEZ1V2dGslMjIlMkMlMjJyZWZlcmVuY2VUeXBlJTIyJTNBJTIyZ29vZ2xlX3BsYWNlcyUyMiUyQyUyMmxhdGl0dWRlJTIyJTNBNTMuNDgwNzU5MyUyQyUyMmxvbmdpdHVkZSUyMiUzQS0yLjI0MjYzMDUlN0Q%3D',
        orderlink: 'https://www.ubereats.com/gb/store/freddy-%26-hicks/pK8BzomcWemHJZYIs43zzQ?diningMode=DELIVERY&pl=JTdCJTIyYWRkcmVzcyUyMiUzQSUyMk1hbmNoZXN0ZXIlMjIlMkMlMjJyZWZlcmVuY2UlMjIlM0ElMjJDaElKMl9VbVVreE5la2dScW12LUJEZ1V2dGslMjIlMkMlMjJyZWZlcmVuY2VUeXBlJTIyJTNBJTIyZ29vZ2xlX3BsYWNlcyUyMiUyQyUyMmxhdGl0dWRlJTIyJTNBNTMuNDgwNzU5MyUyQyUyMmxvbmdpdHVkZSUyMiUzQS0yLjI0MjYzMDUlN0Q%3D',
    },
    {
        id: 3,
        name: 'Sam & Natalie Stonehouse',
        category: 'female_chef',
        restaurant: 'The Bagelry',
        location: 'Liverpool',
        instagram: 'https://www.instagram.com/bagelrypool/?hl=en',
        description: `Our business is female owned and we have a predominantly female team, with women in all managerial and leadership roles. We believe in empowering our team by providing training and development opportunities as well as progression within the business. We also believe in work-life balance and so we make sure our team has a few days off in a row, do not work unsociable hours and also have a balance working weekends and weekdays.

Thriving as a small independent business in today’s climate is difficult, especially within an ever expanding City such as Liverpool where competition is growing. We are constantly having to rethink and reshape our business to stand out in the crowd. We thrived throughout lockdown and grew from this experience, changing our business model from a more relaxed, sit in café to a delivery service and fast paced fast food service in store.   

Over the years we have been involved in many community events and supported local groups and charities. We have provided out of hours shop use for a transgender support group; sponsored a local LGBTQI+ rugby team; taken part in Liverpool PRIDE; supported local artists to create our logos and merch, and last year we hosted LFC players as part of their ‘work experience’ series. We will also be providing placement opportunities for a local College in the coming weeks.`,
        image: ['trailblazers/SamandNat.jpg', 'trailblazers/TheBagelry_2.jpg', 'trailblazers/TheBagelry_3.jpg'], // 'placeholder-trailblazers/nom1.jpg', // Supports Carousels: ['placeholder-trailblazers/nom1.jpg', 'placeholder-trailblazers/nom2.jpg', 'placeholder-trailblazers/nom3.jpg'],
        winImage: '2023-winners/female-chef-2023.jpg',
        sharelink: 'https://www.ubereats.com/gb/store/the-bagelry/NIUptebEVAaMGHEj8Fk9mw?diningMode=DELIVERY&pl=JTdCJTIyYWRkcmVzcyUyMiUzQSUyMk1hbmNoZXN0ZXIlMjIlMkMlMjJyZWZlcmVuY2UlMjIlM0ElMjJDaElKMl9VbVVreE5la2dScW12LUJEZ1V2dGslMjIlMkMlMjJyZWZlcmVuY2VUeXBlJTIyJTNBJTIyZ29vZ2xlX3BsYWNlcyUyMiUyQyUyMmxhdGl0dWRlJTIyJTNBNTMuNDgwNzU5MyUyQyUyMmxvbmdpdHVkZSUyMiUzQS0yLjI0MjYzMDUlN0Q%3D',
        orderlink: 'https://www.ubereats.com/gb/store/the-bagelry/NIUptebEVAaMGHEj8Fk9mw?diningMode=DELIVERY&pl=JTdCJTIyYWRkcmVzcyUyMiUzQSUyMk1hbmNoZXN0ZXIlMjIlMkMlMjJyZWZlcmVuY2UlMjIlM0ElMjJDaElKMl9VbVVreE5la2dScW12LUJEZ1V2dGslMjIlMkMlMjJyZWZlcmVuY2VUeXBlJTIyJTNBJTIyZ29vZ2xlX3BsYWNlcyUyMiUyQyUyMmxhdGl0dWRlJTIyJTNBNTMuNDgwNzU5MyUyQyUyMmxvbmdpdHVkZSUyMiUzQS0yLjI0MjYzMDUlN0Q%3D',
    },
    

    {
        id: 4,
        name: 'Tofu Vegan',
        category: 'sustainable_restaurant',
        restaurant: 'Tofu Vegan',
        location: 'London',
        instagram: 'https://www.instagram.com/tofuveganlondon/?hl=en',
        description: `Taking on the challenge of being one of the first Chinese Vegan restaurants in UK.

Tofu Vegan's impact on the Vegan community has been massive which we are aiming to, and we will keep going to work hard offering the best to our customers. They can now indulge themselves with an extensive menu. 

We offer freshly cooked dishes, home made Tofu all free from unnecessary products.

We go beyond just cooking the food. 

Our team know how best to recommend and combine the different tastes and textures to give our guest an inspiring way to enjoy what Tofu Vegan has to offer.

Our majority ( more than 65 percent ) regular customers who keep coming back are meat eaters, that shows something special and makes Tofu standing out among those. `,
        image: ['trailblazers/TofuVegan.jpg', 'trailblazers/TofuVegan2.jpg', 'trailblazers/TofuVegan3.jpg', 'trailblazers/TofuVegan4.jpg'], // 'placeholder-trailblazers/nom2.jpg',
        winImage: 'trailblazers/winners/TofuVegan.jpg',
        isWinner: false,
        sharelink: 'https://www.ubereats.com/gb/store/tofu-vegan-angel/_IuNZPeySoCFYPDxBepDkw?chain_slug=tofu-vegan&diningMode=DELIVERY&mod=storeDeliveryTime&modctx=%257B%2522entryPoint%2522%253A%2522store-auto-surface%2522%252C%2522encodedStoreUuid%2522%253A%2522_IuNZPeySoCFYPDxBepDkw%2522%257D&pl=JTdCJTIyYWRkcmVzcyUyMiUzQSUyMkxvbmRvbiUyMiUyQyUyMnJlZmVyZW5jZSUyMiUzQSUyMkNoSUpkZDRocnd1ZzJFY1JtU3JWM1ZvNmxsSSUyMiUyQyUyMnJlZmVyZW5jZVR5cGUlMjIlM0ElMjJnb29nbGVfcGxhY2VzJTIyJTJDJTIybGF0aXR1ZGUlMjIlM0E1MS41MDcyMTc4JTJDJTIybG9uZ2l0dWRlJTIyJTNBLTAuMTI3NTg2MiU3RA%3D%3D&ps=1',
        orderlink: 'https://www.ubereats.com/gb/store/tofu-vegan-angel/_IuNZPeySoCFYPDxBepDkw?chain_slug=tofu-vegan&diningMode=DELIVERY&mod=storeDeliveryTime&modctx=%257B%2522entryPoint%2522%253A%2522store-auto-surface%2522%252C%2522encodedStoreUuid%2522%253A%2522_IuNZPeySoCFYPDxBepDkw%2522%257D&pl=JTdCJTIyYWRkcmVzcyUyMiUzQSUyMkxvbmRvbiUyMiUyQyUyMnJlZmVyZW5jZSUyMiUzQSUyMkNoSUpkZDRocnd1ZzJFY1JtU3JWM1ZvNmxsSSUyMiUyQyUyMnJlZmVyZW5jZVR5cGUlMjIlM0ElMjJnb29nbGVfcGxhY2VzJTIyJTJDJTIybGF0aXR1ZGUlMjIlM0E1MS41MDcyMTc4JTJDJTIybG9uZ2l0dWRlJTIyJTNBLTAuMTI3NTg2MiU3RA%3D%3D&ps=1',
    },
    {
        id: 5,
        name: 'Loki Poke',
        category: 'sustainable_restaurant',
        restaurant: 'Loki Poke',
        location: 'Bristol',
        instagram: 'https://www.instagram.com/lokipokeuk/?hl=en',
        description: `We recently won the Sustainability Award at the British Street Food Awards - evaluated by the The Sustainable Restaurant Association, for ""going above and beyond to ensure that their food not only tastes good, but does good too"". We were chosen for the award for excelling in three areas: Sourcing, Society and the Environment.

As a business owner, I have worked hard to prioritise the following:

1) Working only with suppliers who care as much about the ethics and sustainability of their ingredients as we do.
2) Being responsible with the ingredients we choose to put on our menu.
3) Making the effort to support and really be part of our local community.
4) Looking after our team and creating a work environment that is supportive, fun, offers fair pay, and rewards and encourages progression.

SOURCING
Most of our main ingredients are traceable back to farm or fishery:
Our meat is 100% organic and locally sourced from Stream Farms (a local organic farm which practices sustainable and regenerative farming). We are supplied our meat by Beast Butchers, a local family butcher.
We buy our salmon from Loch Duart, a low-impact Scottish farm that prioritises fish quality while maintaining a low carbon footprint. 
We’ve swapped the sashimi tuna on our menu (typically sourced from the Indian Ocean or the Western Pacific Ocean) for Hampshire Chalk Stream Trout, a locally sourced, sustainable alternative.

ENVIRONMENT
We’ve used carbon footprint software to analyse our events and festival menu, so we could adapt our recipes, ingredients, and where we source certain items from to help us reduce our carbon footprint.

SOCIETY
Our work with local charities including donating food and equipment to Feed The Homeless, and raising money for the Mazi Project (a local charity working to empower marginalised 16- to 25-year-olds through food).`,
        image: ['trailblazers/loki_poke_1.jpg', 'trailblazers/loki_poke_2.jpeg'], // 'placeholder-trailblazers/nom2.jpg',
        isWinner: true,
        winImage: '2024-winners/loki-poki-2024.jpg',
        sharelink: 'https://www.ubereats.com/gb/store/loki-poke/ktD1gfGzUsqeBJ2kz379zA?diningMode=DELIVERY&pl=JTdCJTIyYWRkcmVzcyUyMiUzQSUyMk1hbmNoZXN0ZXIlMjIlMkMlMjJyZWZlcmVuY2UlMjIlM0ElMjJDaElKMl9VbVVreE5la2dScW12LUJEZ1V2dGslMjIlMkMlMjJyZWZlcmVuY2VUeXBlJTIyJTNBJTIyZ29vZ2xlX3BsYWNlcyUyMiUyQyUyMmxhdGl0dWRlJTIyJTNBNTMuNDgwNzU5MyUyQyUyMmxvbmdpdHVkZSUyMiUzQS0yLjI0MjYzMDUlN0Q%3D',
        orderlink: 'https://www.ubereats.com/gb/store/loki-poke/ktD1gfGzUsqeBJ2kz379zA?diningMode=DELIVERY&pl=JTdCJTIyYWRkcmVzcyUyMiUzQSUyMk1hbmNoZXN0ZXIlMjIlMkMlMjJyZWZlcmVuY2UlMjIlM0ElMjJDaElKMl9VbVVreE5la2dScW12LUJEZ1V2dGslMjIlMkMlMjJyZWZlcmVuY2VUeXBlJTIyJTNBJTIyZ29vZ2xlX3BsYWNlcyUyMiUyQyUyMmxhdGl0dWRlJTIyJTNBNTMuNDgwNzU5MyUyQyUyMmxvbmdpdHVkZSUyMiUzQS0yLjI0MjYzMDUlN0Q%3D',
    },

    {
        id: 12,
        name: 'The Street Food Chef',
        category: 'sustainable_restaurant',
        restaurant: 'The Street Food Chef',
        location: 'Sheffield',
        instagram: 'https://www.instagram.com/streetfoodchefsheffield/',
        description: `We’re a family run Mexican street food outlet passionate about providing a healthy fast food alternative to the people of Sheffield. We began selling our food in 2010 on Sheffield’s streets and have been massively supported by the local community. We've received five awards from Eat Sheffield, and are proud to have a reader recommendation in the Good Food Guide and a runner up award in the Observer Food Awards.

We make sure all our food is from local business ensuring they're healthy and supporting local business. Which also adds to climate impact as everything delivered and sourced locally. We believe that fast food can taste great, without any of the added nasties – all our food is freshly prepared every day and we use locally sourced, fresh ingredients wherever possible. We make a point of working with local businesses.`,
        image:  ['trailblazers/Street_food_chef_1.jpg', 'trailblazers/street_food_chef_2.jpg'], // 'placeholder-trailblazers/nom3.jpg',
        winImage: 'trailblazers/Street_food_chef_1.jpg',
        sharelink: 'https://www.ubereats.com/gb/store/the-street-food-chef-the-canteen/QsFFz9TDXgKhy5s2dddN9A?diningMode=DELIVERY&pl=JTdCJTIyYWRkcmVzcyUyMiUzQSUyMk1hbmNoZXN0ZXIlMjIlMkMlMjJyZWZlcmVuY2UlMjIlM0ElMjJDaElKMl9VbVVreE5la2dScW12LUJEZ1V2dGslMjIlMkMlMjJyZWZlcmVuY2VUeXBlJTIyJTNBJTIyZ29vZ2xlX3BsYWNlcyUyMiUyQyUyMmxhdGl0dWRlJTIyJTNBNTMuNDgwNzU5MyUyQyUyMmxvbmdpdHVkZSUyMiUzQS0yLjI0MjYzMDUlN0Q%3D',
        orderlink: 'https://www.ubereats.com/gb/store/the-street-food-chef-the-canteen/QsFFz9TDXgKhy5s2dddN9A?diningMode=DELIVERY&pl=JTdCJTIyYWRkcmVzcyUyMiUzQSUyMk1hbmNoZXN0ZXIlMjIlMkMlMjJyZWZlcmVuY2UlMjIlM0ElMjJDaElKMl9VbVVreE5la2dScW12LUJEZ1V2dGslMjIlMkMlMjJyZWZlcmVuY2VUeXBlJTIyJTNBJTIyZ29vZ2xlX3BsYWNlcyUyMiUyQyUyMmxhdGl0dWRlJTIyJTNBNTMuNDgwNzU5MyUyQyUyMmxvbmdpdHVkZSUyMiUzQS0yLjI0MjYzMDUlN0Q%3D',
    },
    
    {
        id: 6,
        name: 'Burger Drop',
        category: 'social_impact',
        restaurant: 'Burger Drop',
        location: 'Newcastle',
        instagram: 'https://www.instagram.com/burgerdropuk/',
        description: `What may be small change for our customers, can be life changing for others. Charity is a core part of our business, from our charity buckets in our restaurant to our own donations from business profit; here is what we have achieved so far.

2024 - £80,000 raised for Syrian & Palestinian Refugee Camps in Lebanon.

2023 - 2x Homes Built for Syrian Refugees.

2022 - £200 raised and an awareness campaign ran for the local People’s Kitchen.

2021 - £1,000 raised to celebrate selling our 10,000th burger was donated to a national mental health charity, Mental Health Concern.`,
        image: ['trailblazers/Burger_Drop_1.jpg', 'trailblazers/Burger_Drop_2.jpg',], // 'placeholder-trailblazers/nom2.jpg',
        winImage: '2024-winners/burger-drop-2024.jpg',
        isWinner: true,
        sharelink: 'https://www.ubereats.com/gb/store/burger-drop-westgate-road/uwcKQAubQSy0UbcvHrYovg?diningMode=DELIVERY&pl=JTdCJTIyYWRkcmVzcyUyMiUzQSUyMk1hbmNoZXN0ZXIlMjIlMkMlMjJyZWZlcmVuY2UlMjIlM0ElMjJDaElKMl9VbVVreE5la2dScW12LUJEZ1V2dGslMjIlMkMlMjJyZWZlcmVuY2VUeXBlJTIyJTNBJTIyZ29vZ2xlX3BsYWNlcyUyMiUyQyUyMmxhdGl0dWRlJTIyJTNBNTMuNDgwNzU5MyUyQyUyMmxvbmdpdHVkZSUyMiUzQS0yLjI0MjYzMDUlN0Q%3D',
        orderlink: 'https://www.ubereats.com/gb/store/burger-drop-westgate-road/uwcKQAubQSy0UbcvHrYovg?diningMode=DELIVERY&pl=JTdCJTIyYWRkcmVzcyUyMiUzQSUyMk1hbmNoZXN0ZXIlMjIlMkMlMjJyZWZlcmVuY2UlMjIlM0ElMjJDaElKMl9VbVVreE5la2dScW12LUJEZ1V2dGslMjIlMkMlMjJyZWZlcmVuY2VUeXBlJTIyJTNBJTIyZ29vZ2xlX3BsYWNlcyUyMiUyQyUyMmxhdGl0dWRlJTIyJTNBNTMuNDgwNzU5MyUyQyUyMmxvbmdpdHVkZSUyMiUzQS0yLjI0MjYzMDUlN0Q%3D',
    },
    {
        id: 7,
        name: 'Alfie\'s',
        category: 'social_impact',
        restaurant: 'Alfie\'s',
        location: 'Newcastle',
        instagram: 'https://www.instagram.com/alfiesfriedchicken/',
        description: `We are a neighbourhood bar and restaurant always looking to give back to community in all aspects of our work. 

Our main social impact is the close work we do with Cash for Kids who’s mission is to improve the lives of disadvantaged children and young people in our communities who are affected by poverty, illness, neglect or have additional needs. 

We push for donations across our Alfies & our other brand Brack Burger and also promote Alfie’s as a collection point for there Christmas campaign, Mission Christmas, where we were flooded with toys and gifts for the charity. We also host a Christmas party each year where every penny from the bar in sales as well as auctions as well as other monetary fundraising ideas. Last year alone we raised £7200 and collected over 200 toys!

This year we have done £5000 in donations so far before the main Christmas campaign has even begun! We would be looking at donating any prize money from this award to our chosen charity to further support them. `,
        image: ['trailblazers/Alfies_1.jpg', 'trailblazers/Alfies_2.jpg', ], // 'placeholder-trailblazers/nom2.jpg',
        winImage: '2023-winners/sustainable-2023.jpg',
        sharelink: 'https://www.ubereats.com/gb/store/alfies-fried-chicken/66-VLJAFWsCpO4U3vj3DBQ?diningMode=DELIVERY&pl=JTdCJTIyYWRkcmVzcyUyMiUzQSUyMk1hbmNoZXN0ZXIlMjIlMkMlMjJyZWZlcmVuY2UlMjIlM0ElMjJDaElKMl9VbVVreE5la2dScW12LUJEZ1V2dGslMjIlMkMlMjJyZWZlcmVuY2VUeXBlJTIyJTNBJTIyZ29vZ2xlX3BsYWNlcyUyMiUyQyUyMmxhdGl0dWRlJTIyJTNBNTMuNDgwNzU5MyUyQyUyMmxvbmdpdHVkZSUyMiUzQS0yLjI0MjYzMDUlN0Q%3D',
        orderlink: 'https://www.ubereats.com/gb/store/alfies-fried-chicken/66-VLJAFWsCpO4U3vj3DBQ?diningMode=DELIVERY&pl=JTdCJTIyYWRkcmVzcyUyMiUzQSUyMk1hbmNoZXN0ZXIlMjIlMkMlMjJyZWZlcmVuY2UlMjIlM0ElMjJDaElKMl9VbVVreE5la2dScW12LUJEZ1V2dGslMjIlMkMlMjJyZWZlcmVuY2VUeXBlJTIyJTNBJTIyZ29vZ2xlX3BsYWNlcyUyMiUyQyUyMmxhdGl0dWRlJTIyJTNBNTMuNDgwNzU5MyUyQyUyMmxvbmdpdHVkZSUyMiUzQS0yLjI0MjYzMDUlN0Q%3D',
    },
    {
        id: 8,
        name: 'China Red 满庭红',
        category: 'social_impact',
        restaurant: 'China Red 满庭红',
        location: 'Sheffield',
        instagram: 'https://www.instagram.com/chinaredsheffield/',
        description: `Community Engagement:

We actively participate in local community events and fundraising activities. For example, we've supported charities like Sheffield Children Hospital, Mums In Need, Roundabout, and Archer Project. We foster a sense of unity and cultural appreciation by engaging with diverse community groups and delivering events that bridge cultural gaps and promote inclusivity. Notably, the Sheffield Lunar Chinese New Year Festival, supported by """"China Red,"""" has raised over £18k for Sheffield Children Hospital Charity.

Cultural Awareness:

We highlight Chinese culture through various events, performances, and displays, increasing cultural awareness and understanding among the wider community. This promotes respect and appreciation for cultural diversity.

Economic Impact:
As a key stakeholder in the Sheffield Lunar Chinese New Year Festival, """"China Red"""" helps bring the South East Asian community together to deliver a city event that attracts an additional 35k visitors to Sheffield City Centre. This boost in footfall benefits local businesses and the overall economy.

Collaboration and Partnerships:
We collaborate with organizations like Sheffield City Council, Sheffield Chamber of Commerce, and international partners such as the Foshan Municipal Government and Chengdu City. These partnerships enhance the quality and reach of our projects, bringing unique cultural elements and fostering international connections.

Our efforts contributed to the signing of the Twin City connection between Chengdu (China) and Sheffield (UK).`,
        image: 'trailblazers/ChinaRed_1.jpeg', // 'placeholder-trailblazers/nom2.jpg',
        winImage: '2023-winners/sustainable-2023.jpg',
        sharelink: 'https://www.ubereats.com/gb/store/china-red-%E6%BB%A1%E5%BA%AD%E7%BA%A2/3RcUJcafR4y53_przXyPug?diningMode=DELIVERY&pl=JTdCJTIyYWRkcmVzcyUyMiUzQSUyMk1hbmNoZXN0ZXIlMjIlMkMlMjJyZWZlcmVuY2UlMjIlM0ElMjJDaElKMl9VbVVreE5la2dScW12LUJEZ1V2dGslMjIlMkMlMjJyZWZlcmVuY2VUeXBlJTIyJTNBJTIyZ29vZ2xlX3BsYWNlcyUyMiUyQyUyMmxhdGl0dWRlJTIyJTNBNTMuNDgwNzU5MyUyQyUyMmxvbmdpdHVkZSUyMiUzQS0yLjI0MjYzMDUlN0Q%3D',
        orderlink: 'https://www.ubereats.com/gb/store/china-red-%E6%BB%A1%E5%BA%AD%E7%BA%A2/3RcUJcafR4y53_przXyPug?diningMode=DELIVERY&pl=JTdCJTIyYWRkcmVzcyUyMiUzQSUyMk1hbmNoZXN0ZXIlMjIlMkMlMjJyZWZlcmVuY2UlMjIlM0ElMjJDaElKMl9VbVVreE5la2dScW12LUJEZ1V2dGslMjIlMkMlMjJyZWZlcmVuY2VUeXBlJTIyJTNBJTIyZ29vZ2xlX3BsYWNlcyUyMiUyQyUyMmxhdGl0dWRlJTIyJTNBNTMuNDgwNzU5MyUyQyUyMmxvbmdpdHVkZSUyMiUzQS0yLjI0MjYzMDUlN0Q%3D',
    },

    {
        id: 9,
        name: 'Urban Health',
        category: 'health_focused',
        restaurant: 'Urban Health',
        location: 'Dublin',
        instagram: 'https://www.instagram.com/urbanhealth_ie/?hl=en',
        description: `Since 2014 Urban Health has been promoting healthy eating and providing our customers with healthier alternatives to their most loved dishes. We were one of the first healthy eating cafe's in dublin and have made a hugely positive impact on our beloved area of Ranelagh by offering our community healthy food choices.

We specialise in cold pressed juices, vegan friendly foods including salads, wraps, breakfast and brunch dishes, smoothie bowls, açai and healthy raw treats. Our cold pressed juice cleanses are one of our top selling products which we deliver all over Ireland. We make all our food in house with our amazing team of chefs and we always try to offer a plant based option on all menu items we create. We use fresh, seasonal ingredients from top quality suppliers within Ireland. Our eggs are free-range and our meats are sourced from top Irish suppliers. We like to support other small businesses as much as possible and offer a range of off the shelf products from a number of local Irish businesses. We are 95% general waste free and all of our packaging is either compostable or recyclable. 

We believe in gently encouraging people to choose more plant based alternatives and by doing so, cut down on their intake of animal products in the hope that it might have a positive effect on both the environment and on peoples health and wellbeing. We believe in promoting healthy eating in a holistic way and believe that what you put into your body effects how you feel and your mental health. By providing people with healthier alternatives we hope that it will lead to an overall more positive mindset for our customers and the community around us.`,
        image: ['trailblazers/Urban_health_1.jpeg', 'trailblazers/Urban_health_2.jpeg'], // 'placeholder-trailblazers/nom4.jpg',
        winImage: '2024-winners/urban-health-2024.jpg',
        isWinner: true,
        sharelink: 'https://www.ubereats.com/ie/store/urban-health-ranelagh/tIVWYXUsUcW7dA4C3FngQw?diningMode=DELIVERY&pl=JTdCJTIyYWRkcmVzcyUyMiUzQSUyMk1hbmNoZXN0ZXIlMjIlMkMlMjJyZWZlcmVuY2UlMjIlM0ElMjJDaElKMl9VbVVreE5la2dScW12LUJEZ1V2dGslMjIlMkMlMjJyZWZlcmVuY2VUeXBlJTIyJTNBJTIyZ29vZ2xlX3BsYWNlcyUyMiUyQyUyMmxhdGl0dWRlJTIyJTNBNTMuNDgwNzU5MyUyQyUyMmxvbmdpdHVkZSUyMiUzQS0yLjI0MjYzMDUlN0Q%3D',
        orderlink: 'https://www.ubereats.com/ie/store/urban-health-ranelagh/tIVWYXUsUcW7dA4C3FngQw?diningMode=DELIVERY&pl=JTdCJTIyYWRkcmVzcyUyMiUzQSUyMk1hbmNoZXN0ZXIlMjIlMkMlMjJyZWZlcmVuY2UlMjIlM0ElMjJDaElKMl9VbVVreE5la2dScW12LUJEZ1V2dGslMjIlMkMlMjJyZWZlcmVuY2VUeXBlJTIyJTNBJTIyZ29vZ2xlX3BsYWNlcyUyMiUyQyUyMmxhdGl0dWRlJTIyJTNBNTMuNDgwNzU5MyUyQyUyMmxvbmdpdHVkZSUyMiUzQS0yLjI0MjYzMDUlN0Q%3D',
    },

    {
        id: 10,
        name: 'Eat Clean',
        category: 'health_focused',
        restaurant: 'Eat Clean',
        location: 'Newcastle',
        instagram: 'https://www.instagram.com/eatclean.uk/',
        description: `Our healthy eating business Eat Clean in Whitley Bay excels by offering a unique blend of convenience, quality, and community focus. We stand out by providing freshly prepared, nutritionally balanced meals that cater to all ages, ensuring that our offerings are both delicious and health-conscious. What sets us apart is our commitment to sourcing the highest quality ingredients, including grade A chicken and grass-fed beef, directly from local suppliers. This not only guarantees freshness but also supports the local economy.

Eat Clean collaborates closely with local gyms, tailoring meal plans to meet specific fitness goals, and actively engage with the community through events and partnerships. Our impact is evident in the healthier lifestyles we promote, the strong relationships we’ve built with local businesses, and the positive feedback from our customers. By prioritizing both taste and nutrition, we’ve become a trusted hub for healthy living in Whitley Bay, making a tangible difference in our community’s well-being.`,
        image:  ['trailblazers/EatClean_1.jpeg', 'trailblazers/EatClean_2.jpeg',], // 'placeholder-trailblazers/nom4.jpg',
        winImage: 'trailblazers/winners/EatClean_1.jpg',
        isWinner: false,
        sharelink: 'https://www.ubereats.com/gb/store/eat-clean/tiE_FSxqTNy4H-GkJdyIIQ?srsltid=AfmBOoqrb9_zj1Herd8SNfqUIOjCgDJuv3simB14nb_3zLPOCAljgwFR',
        orderlink: 'https://www.ubereats.com/gb/store/eat-clean/tiE_FSxqTNy4H-GkJdyIIQ?srsltid=AfmBOoqrb9_zj1Herd8SNfqUIOjCgDJuv3simB14nb_3zLPOCAljgwFR',
    },

    {
        id: 11,
        name: 'Happy Maki',
        category: 'health_focused',
        restaurant: 'Happy Maki',
        location: 'Brighton',
        instagram: 'https://www.instagram.com/thehappymaki/?hl=en',
        description: `I believe Happy Maki is the perfect solution to healthy, filling and delicious food. You can eat Happy Maki 7 days in a week and still feel great, I and many others have tried and tested this and its true. All of our salads and sauces are home made containing whole-foods ingredients, for example, our carrot salad is marinated in orange juice, turmeric and fresh ginger and garlic.

Our home made miso soup contained a 7 blend mushroom powder and is garnished with fresh sprouted mung beans.  We slip in the really good stuff wherever we can! Our menu is also gluten free friendly which helps so many people who have big and small adverse reactions to gluten heavy meals. 

We use a lot of herbs in our sushi, and every-meal of ours is packed with freshly prepped vegetables meaning our sushi burritos and bowls are bursting with colour and nutrients.I have long been passionate about public health and healthy food doesn't need to be boring or not filling.

I believe we have found the sweet spot between satisfying and nourishing.`,
        image: ['trailblazers/HappyMaki_1.jpeg', 'trailblazers/Happy_Maki2.jpg',], // 'placeholder-trailblazers/nom4.jpg',
        winImage: '2023-winners/health-2023.jpg',
        sharelink: 'https://www.ubereats.com/gb/store/happy-maki-burritos-%26-bowls/zdo_GJN1QeOcv4l5MRTbGQ?diningMode=DELIVERY&pl=JTdCJTIyYWRkcmVzcyUyMiUzQSUyMk1hbmNoZXN0ZXIlMjIlMkMlMjJyZWZlcmVuY2UlMjIlM0ElMjJDaElKMl9VbVVreE5la2dScW12LUJEZ1V2dGslMjIlMkMlMjJyZWZlcmVuY2VUeXBlJTIyJTNBJTIyZ29vZ2xlX3BsYWNlcyUyMiUyQyUyMmxhdGl0dWRlJTIyJTNBNTMuNDgwNzU5MyUyQyUyMmxvbmdpdHVkZSUyMiUzQS0yLjI0MjYzMDUlN0Q%3D',
        orderlink: 'https://www.ubereats.com/gb/store/happy-maki-burritos-%26-bowls/zdo_GJN1QeOcv4l5MRTbGQ?diningMode=DELIVERY&pl=JTdCJTIyYWRkcmVzcyUyMiUzQSUyMk1hbmNoZXN0ZXIlMjIlMkMlMjJyZWZlcmVuY2UlMjIlM0ElMjJDaElKMl9VbVVreE5la2dScW12LUJEZ1V2dGslMjIlMkMlMjJyZWZlcmVuY2VUeXBlJTIyJTNBJTIyZ29vZ2xlX3BsYWNlcyUyMiUyQyUyMmxhdGl0dWRlJTIyJTNBNTMuNDgwNzU5MyUyQyUyMmxvbmdpdHVkZSUyMiUzQS0yLjI0MjYzMDUlN0Q%3D',
    },
    
] */

export function findNomineeData(search) {
    search = search.toLowerCase();
    // replace - with '' in the search string
    search = search.replace(/-/g, '');
    for (const nominee of NOMINEES) {
        const n = nominee.name.toLowerCase().replace(/ /g, '');
        const r = nominee.restaurant.toLowerCase().replace(/ /g, '');
        if (nominee.name.toLowerCase() === search || n === search || r === search || nominee.instagram === search || nominee.id === parseInt(search)) {
            return nominee;
        }
        if (nominee.match) {
            if (nominee.match === search) {
                return nominee;
            }
            if (Array.isArray(nominee.match)) {
                if (nominee.match.includes(search)) {
                    return nominee;
                }
            }
        }
    }
    // Not found
    return null;
}
